<template>
  <div class="flex flex-wrap -mx-2">
    <div class="w-full sm:w-1/2 lg:w-1/4 px-2 mb-4" v-for="card in cards" :key="card.label">
      <vx-card>
        <div class="flex items-center justify-between">
          <div>
            <p class="text-grey mb-1">{{ card.label }}</p>
            <h2 class="font-bold">{{ card.value }}</h2>
          </div>
          <div class="p-3 rounded-full" :class="card.bgClass">
            <feather-icon :icon="card.icon" svgClasses="w-6 h-6 text-white" />
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
export default {
  name: "AnalyticsKpiCards",
  props: {
    data: { type: Object, required: true },
  },
  computed: {
    cards() {
      return [
        {
          label: "Umsatz heute",
          value: this.formatCurrency(this.data.revenueToday),
          icon: "DollarSignIcon",
          bgClass: "bg-primary",
        },
        {
          label: "Bestellungen heute",
          value: this.data.ordersToday,
          icon: "ShoppingCartIcon",
          bgClass: "bg-success",
        },
        {
          label: "Ø Bestellwert",
          value: this.formatCurrency(this.data.avgOrderValue),
          icon: "TrendingUpIcon",
          bgClass: "bg-warning",
        },
        {
          label: "Kunden gesamt",
          value: this.data.totalCustomers,
          icon: "UsersIcon",
          bgClass: "bg-danger",
        },
      ];
    },
  },
  methods: {
    formatCurrency(val) {
      return Number(val).toFixed(2) + " €";
    },
  },
};
</script>
